<!-- 所需参数
@tipsType 背景色，四种种可选success,warn,error,message
@info 提示信息
@isLink 是否显示链接 非必选
@isIcon 是否显示前面图标 非必选
@time  toast持续事件  非必选
@isAuto  是否自动关闭   默认自动关闭
-->
<template>
  <transition name="fade">
    <!-- toast -->
    <div
      v-show="show"
      ref="tips"
      class="tips auto-position"
      :class="toastInfo.tipsType"
    >
      <!-- toast内容 -->
      <slot name="text">
        <span class="tips-text">
          <!-- 图标插槽 -->
          <slot name="icon">
            <span
              v-if="isIcon"
              class="tips-icon"
            >
              <svg class="icon-svg">
                <use :xlink:href="svgType" />
              </svg>
            </span>
          </slot>
          {{ $t(toastInfo.info) }}
        </span>
      </slot>
      <!-- 链接 -->
      <div
        class="tips-link"
        @click="hrefClick"
      >
        <slot name="link">
          <a
            v-if="isLink"
            class="tips-btn"
          >{{ toastLink }}</a>
        </slot>
      </div>

      <!-- 关闭图标 -->
      <span
        v-if="closeIcon"
        class="tips-close"
        @click="closeToast"
      >
        <svg class="close-svg">
          <use xlink:href="#close" />
        </svg>
      </span>
    </div>
  </transition>
</template>
<script>
/*
 * @Author: lisiyi
 * @Date: 2019-12-20 14:43
 * @Last Modified by: lisiyi
 * @Last Modified time: 2019-12-20 14:43
 */
export default {
  props: {
    toastInfo: {
      // toast内容类型
      type: Object,
      default: () => ({
        info: '成功',
        tipsType: 'success',
      }),
    },
    value: {
      // toast显隐，v-model绑定
      type: Boolean,
      default: false,
    },
    isLink: {
      // 是否显示链接
      type: Boolean,
      default: false,
    },
    isIcon: {
      // 是否显示图标
      type: Boolean,
      default: true,
    },
    isAuto: {
      // 是否自动关闭
      type: Boolean,
      default: true,
    },
    time: {
      // 弹框如果自动关闭 持续时间
      type: Number,
      default: 3000,
    },
    toastLink: {
      // 链接文字
      type: String,
      default: '按钮',
    },
    closeIcon: {
      // 关闭按钮
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: true, // toast显隐状态位
      timer: null, // 定时关闭函数
    }
  },
  computed: {
    /**
       * 获取图标类型
       */
    svgType() {
      const cfg = {
        success: '#success',
        warn: '#warn',
        error: '#error',
      }
      return cfg[this.toastInfo.tipsType] || '#message'
    },
  },
  watch: {
    value(n, o) {
      this.show = n
    },
    show(n, o) {
      this.$emit('input', n)
    },
  },
  created() {
    this.show = this.value
  },
  updated() {
    // 定时关闭函数
    if (this.show && this.isAuto) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.closeToast()
      }, this.time)
    }
  },
  methods: {
    /**
     *    关闭事件
     */
    closeToast() {
      this.show = false
      this.$emit('close')
    },
    /**
     * 点击标签
     */
    hrefClick() {
      this.$emit('go')
    },
  },
}
</script>
<style lang="less" scoped>
a {
  color: #0a64fa;
}
a:hover {
  color: #0a64fa;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s linear;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.tips {
  max-width: 520px;
  line-height: 18px;
  min-width: 200px;
  position: fixed;
  z-index: 100;
  border-radius: 2px;
  text-align: center;
  padding: 10px 24px;
  font-size: 14px;
  color: #6a6a68;
}
.notice { // 黑底白字的通知提示
  background: rgba(0,0,0,0.59);
  border-radius: 4px;
  color: #ffffff;
  padding: 0px 14px;
  line-height: 50px;
  font-size: 18px;
  width: auto;
  border: none;
  min-width: auto;
}
.message {
  background: #f0f2f6;
  border: 1px solid #929ca9;
  color: #637282;
}
.success {
  background: #f0f9ea;
  border: 1px solid #2dcc71;
  color: #2dcc71;
}

.error {
  background: #fef0f0;
  border: 1px solid #ff3d3c;
  color: #ff3d3c;
}

.warn {
  background: #fdf6ed;
  border: 1px solid #ffab27;
  color: #ef7309;
}
.success,
.warn,
.error,
.message {
  letter-spacing: 0.17px;
  box-shadow: none;
  text-align: center;
}
.tips-icon {
  display: inline-block;
  height: 14px;
  width: 14px;
  margin-right:8px;
}
.icon-svg {
  margin-bottom: -2px;
  height: 14px;
  width: 14px;
}
.tips-text {
  display: inline-block;
  word-break: break-all;
  min-width: 30px;
}
.tips-link {
  display: inline-block;
  cursor: pointer;
}
.tips-link:hover {
  cursor: hand;
}
.tips-close {
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -6px;
  display: inline-block;
  cursor: pointer;
  line-height: 12px;
  color: #565656;
  width: 12px;
  height: 12px;
}
.tips-close:hover {
  cursor: hand;
}
.close-svg {
  width: 8px;
  height: 8px;
}
.tips-msg {
  display: inline-block;
}
.tips-btn {
  word-break: break-all;
  min-width: 30px;
  display: inline-block;
}
.auto-position {
  top: 100px;
  left: 50%; /*定位margin-left:50%的位置*/
  -webkit-transform: translate(-50%, -50%); /*Safari,Chrome*/
  -moz-transform: translate(-50%, -50%); /*IE9+*/
  transform: translate(-50%, -50%); /*使元素本身向左移动宽度的一半*/
  -ms-transform: translate(-50%, -50%); /*ie*/
}
  .request-not-found{
    &>.tips{
      visibility: hidden;
    }
  }
</style>
